<template>
  <app-modal v-model="isDialogOpened"
             size="xs"
             :ok-text="$t('common.confirm')"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.SigningChecklistOrderDeleteGroupDialog.title') }}</template>

    <template #body>
      <p>{{ $t("project.signing-checklist.SigningChecklistOrderDeleteGroupDialog.warning") }}</p>
    </template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'SigningChecklistOrderDeleteGroupDialog',
  mixins: [dialogMixin],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
